function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.22235 24.1906C8.40238 21.9703 7.48105 19.8058 6.30175 17.7621C5.13167 15.7276 3.7589 13.8418 1.96231 12.2997C1.50165 11.9095 0.985708 11.5844 0.405273 11.2592C0.893576 11.1013 1.34503 11.2035 1.76883 11.1106C2.96656 10.8412 4.09979 10.4789 4.90134 9.44771C5.47256 8.71381 5.55548 7.89631 5.48177 7.03236C5.29751 5.00719 4.33012 3.38148 3.00341 1.92298C2.3677 1.23554 1.70434 0.594546 0.967282 0C1.34503 0.176506 1.72277 0.343722 2.0913 0.538807C4.16428 1.65358 5.96086 3.12137 7.43498 4.97003C8.73405 6.59574 9.70144 8.39796 10.4477 10.3395C10.89 11.5007 11.1756 12.6991 11.5072 13.8975C11.5625 14.0926 11.4427 14.2412 11.3598 14.3992C10.1437 16.5823 9.51718 18.9233 9.37898 21.4129C9.33291 22.2397 9.44347 23.0572 9.39741 23.884C9.35134 24.0048 9.39741 24.1534 9.22235 24.1906Z",
  fill: "#077CA0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 7.22733C0 5.87102 1.02267 4.83057 2.35859 4.83057C3.65766 4.83057 4.77246 5.93605 4.78168 7.23662C4.79089 8.5279 3.64845 9.66125 2.35859 9.66125C1.02267 9.65196 0 8.60222 0 7.22733Z",
  fill: "#077CA0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.28688 23.8932C9.2316 22.8063 9.20396 21.7287 9.3053 20.6417C9.52642 18.2543 10.2451 16.034 11.4612 13.9717C11.4704 13.9531 11.4796 13.9252 11.4888 13.9067C13.3407 10.9432 15.8006 8.64864 18.8963 7.0415C18.6107 7.28304 18.3251 7.51528 18.0487 7.75682C16.5746 9.09455 15.4045 10.6274 14.9622 12.6247C14.5292 14.5941 15.2939 15.9318 17.1826 16.5728C17.5327 16.6936 17.8921 16.7772 18.2514 16.8329C18.6107 16.8887 18.9792 16.898 19.4307 16.9351C18.3343 17.3625 17.4775 18.0034 16.7035 18.7652C15.469 19.9822 14.5569 21.4221 13.7829 22.9735C12.5392 25.4539 11.7007 28.0736 11.0927 30.8512C10.1713 28.761 9.66462 26.6244 9.34216 24.432C9.26845 24.2555 9.36058 24.0697 9.28688 23.8932Z",
  fill: "#78B521"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7262 15.495C16.5284 15.495 15.5795 14.5382 15.5887 13.3398C15.5979 12.1507 16.51 11.231 17.6893 11.2217C18.8962 11.2125 19.8084 12.1507 19.8452 13.3584C19.8913 14.4918 18.7304 15.6065 17.7262 15.495Z",
  fill: "#78B521"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34.1719 17.0002V30.9814H29.8786V24.2184L26.9395 28.148L23.9452 24.1534V30.9814H19.6519V17.0002H23.9452V17.0188H23.9637L26.9211 20.9298L29.8786 17.0467V17.0002H34.1719Z",
  fill: "#077CA0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M44.2604 29.1513H39.8472L39.2115 30.9999L34.6602 30.9814L39.4695 17.0002H44.6197L49.429 30.9814H44.8961L44.2604 29.1513ZM43.0166 25.584L42.04 22.7413L41.0634 25.584H43.0166Z",
  fill: "#077CA0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M58.9555 30.9814H50.249V17.0002H54.5424V26.6245H58.9555V30.9814Z",
  fill: "#077CA0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M64.4743 20.8276V22.1375H70.0667V25.6397H64.4743V27.0332H70.1865V30.9814H60.1625V17.0002H70.1681V20.8276H64.4743Z",
  fill: "#077CA0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M78.3587 26.6059H83.3338V30.9721H70.8683L76.3778 21.3293H71.4027V17.0002H83.8866L78.3587 26.6059Z",
  fill: "#077CA0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M89 30.9814H84.6882V17.0002H89V30.9814Z",
  fill: "#077CA0"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 31,
    viewBox: "0 0 89 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.29b3edac.svg";
export { ForwardRef as ReactComponent };